import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login/login'
import liveList from '@/views/live/liveList'
import live from '@/views/live/live'

import chat from '@/views/chat'
import teacherChat from '@/views/chat/teacherChat'
import psychiatristChat from "@/views/psychiatristChat/psychiatristChat"
import Layout from '@/views/layout/Layout'
import orderDetail from '@/views/orders/orderDetail'
import refundDetail from '@/views/orders/refundDetail'
import consultDetail from '@/views/consult/consultDetail'
Vue.use(Router)

const routes = [{
  path: '/login',
  name: 'login',
  isHide: true,
  component: login
},
{
  path: '/liveList',
  name: 'liveList',
  isHide: true,
  component: liveList
},
{
  path: '/live',
  name: 'live',
  isHide: true,
  component: live
},
{
  path: '/chat',
  name: 'chat',
  isHide: true,
  component: chat
},
{
  path: '/teacherChat',
  name: 'teacherChat',
  isHide: true,
  component: teacherChat
},
// 入驻平台心理咨询师聊天
{
  path: '/psychiatristChat',
  name: 'psychiatristChat',
  isHide: true,
  component: psychiatristChat
},
{
  path: '/',
  component: Layout,
  redirect: '/login',
  children: [{
    path: '/home',
    name: 'home',
    meta: {
      title: '首页',
      icon: 'el-icon-s-home',
    },
    component: () =>
      import('@/views/home/home')
  },]
},
{
  path: '/system',
  component: Layout,
  meta: {
    title: '系统管理',
    icon: 'el-icon-s-tools',
  },
  children: [{
    path: '/role',
    name: 'role',
    meta: {
      title: '角色管理',
      icon: 'el-icon-s-custom',
    },
    component: () =>
      import('@/views/system/role')
  },
  {
    path: '/user',
    name: 'user',
    meta: {
      title: '用户管理',
      icon: 'el-icon-user-solid',
    },
    component: () =>
      import('@/views/system/user')
  },
  {
    path: '/illegalUser',
    name: 'illegalUser',
    meta: {
      title: '违规用户管理',
      icon: 'el-icon-warning'
    },
    component: () =>
      import('@/views/system/illegalUser')
  },
  {
    path: '/consultantType',
    name: 'consultantType',
    meta: {
      title: '从业资格类型证书',
      icon: 'iconfont icon-xuewei'
    },
    component: () =>
      import('@/views/system/consultantType')
  },
  {
    path: '/majorType',
    name: 'majorType',
    meta: {
      title: '咨询师标签管理',
      icon: 'iconfont icon-biaoqian'
    },
    component: () =>
      import('@/views/system/majorType')
  },
  {
    path: '/scale',
    name: 'scale',
    meta: {
      title: '量表管理',
      icon: 'iconfont icon-jiankangwenjuan'
    },
    component: () =>
      import('@/views/system/scale')
  },
  {
    path: '/scaleOrder',
    name: 'scaleOrder',
    meta: {
      title: '量表订单管理',
      icon: 'el-icon-sell'
    },
    component: () =>
      import('@/views/system/scaleOrder')
  },
    // {
    //   path: '/menu',
    //   name: 'menu',
    //   meta: {
    //     title: '菜单管理',
    //     icon: 'el-icon-s-grid'
    //   },
    //   component: () =>
    //     import('@/views/system/menu')
    // },

  ]
},

// 聊天管理
{
  path: '/chatMgr',
  component: Layout,
  meta: {
    title: '聊天管理',
    icon: 'el-icon-chat-dot-square',
  },
  children: [
    {
      path: '/systemChar',
      name: 'systemChar',
      meta: {
        title: '咨询聊天记录',
        icon: 'el-icon-chat-line-square'
      },
      component: () =>
        import('@/views/chat/systemChat')
    },
  ]
},
{
  path: '/attestedmgr',
  component: Layout,
  meta: {
    title: '信息审核管理',
    icon: 'el-icon-s-management'
  },
  children: [{
    path: '/attestation',
    name: 'attestation',
    meta: {
      title: '咨询师认证管理',
      icon: 'el-icon-tickets'
    },
    component: () =>
      import('@/views/attestedmgr/attestation')
  },
  {
    path: '/baseInfo',
    name: 'baseInfo',
    meta: {
      title: '基本信息管理',
      icon: 'el-icon-user-solid'
    },
    component: () =>
      import('@/views/attestedmgr/baseInfo')
  },
  //  {
  //   path: '/consultantInfo',
  //   name: 'consultantInfo',
  //   meta: {
  //     title: '咨询师信息管理',
  //     icon: 'el-icon-tickets'
  //   },
  //   component: () =>
  //     import('@/views/attestedmgr/consultantInfo')
  // }, 
  {
    path: '/violation',
    name: 'violation',
    meta: {
      title: '违规信息管理',
      icon: 'el-icon-monitor',
    },
    component: () =>
      import('@/views/attestedmgr/violation')
  },
  {
    path: '/forum',
    name: 'forum',
    meta: {
      title: '论坛信息管理',
      icon: 'el-icon-monitor',
    },
    component: () =>
      import('@/views/attestedmgr/forum')
  },

  ]
},
//商品管理
{
  path: '/shop',
  component: Layout,
  meta: {
    title: '线上商城管理',
    icon: 'el-icon-picture-outline',
  },
  children: [

    {
      path: '/shop/goodsClass',
      name: 'goodsClass',
      meta: {
        title: '商品分类',
        icon: 'el-icon-s-grid'
      },
      component: () =>
        import('@/views/shop/goodsClass')
    },
    {
      path: '/shop/goods',
      name: 'goods',
      meta: {
        title: '商品管理',
        icon: 'el-icon-s-goods'
      },
      component: () =>
        import('@/views/shop/goods')
    },
    {
      path: '/shop/goodsOrder',
      name: 'goodsOrder',
      meta: {
        title: '商品订单',
        icon: 'el-icon-s-order'
      },
      component: () =>
        import('@/views/shop/goodsOrder')
    },
    {
      path: '/shop/goodsComment',
      name: 'goodsComment',
      meta: {
        title: '商品评价',
        icon: 'el-icon-chat-line-square'
      },
      component: () =>
        import('@/views/shop/goodsComment')
    },

  ]
},

{
  path: '/swiper',
  component: Layout,
  meta: {
    title: '轮播图管理',
    icon: 'el-icon-picture-outline',
  },
  children: [{
    path: '/swiper/homepage',
    name: 'homepage',
    meta: {
      title: '首页轮播',
      icon: 'el-icon-picture-outline'
    },
    component: () =>
      import('@/views/swiper/homepage')
  }, {
    path: '/swiper/scalepage',
    name: 'scalepage',
    meta: {
      title: '量表页轮播',
      icon: 'el-icon-picture'
    },
    component: () =>
      import('@/views/swiper/scalepage')
  }]
},


//订单管理
{
  path: '/orders',
  component: Layout,
  meta: {
    title: '咨询订单管理',
    icon: 'el-icon-s-order',
  },
  children: [{
    path: '/orders/waitPayOrder',
    name: 'waitPayOrder',
    meta: {
      title: '待付款订单',
      icon: 'iconfont icon-hongjiuchengicondaifukuan'
    },
    component: () =>
      import('@/views/orders/waitPayOrder')
  }, {
    path: '/orders/waitOrder',
    name: 'waitOrder',
    meta: {
      title: '待确定订单',
      icon: 'iconfont icon-daifukuan',
    },
    component: () =>
      import('@/views/orders/waitOrder')
  }, {
    path: '/orders/evaluateWaitOrder',
    name: 'evaluateWaitOrder',
    meta: {
      title: '待评价订单',
      icon: 'iconfont icon-el-icon-custom-order'
    },
    component: () =>
      import('@/views/orders/evaluateWaitOrder')
  }, {
    path: '/orders/cancelOrder',
    name: 'cancelOrder',
    meta: {
      title: '取消订单',
      icon: 'iconfont icon-quxiaodingdan'
    },
    component: () =>
      import('@/views/orders/cancelOrder')
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    isHide: true,
    meta: {
      title: '订单详情',
    },
    component: orderDetail
  },
  {
    path: '/refundDetail',
    name: 'refundDetail',
    isHide: true,
    meta: {
      title: '订单审核',
    },
    component: refundDetail
  }
  ]
},
// 咨询服务
// {
//   path: '/service',
//   component: Layout,
//   meta: {
//     title: '咨询管理',
//     icon: 'iconfont icon-zixun'
//   },
//   children: [{
//       path: '/service/waitServiceOrder',
//       name: 'waitServiceOrder',
//       meta: {
//         title: '待服务',
//         icon: 'iconfont icon-shijian',
//       },
//       component: () =>
//         import('@/views/service/waitServiceOrder')
//     }, {
//       path: '/service/servicingOrder',
//       name: 'servicingOrder',
//       meta: {
//         title: '服务中',
//         icon: 'iconfont icon-bofang'
//       },
//       component: () =>
//         import('@/views/service/servicingOrder')
//     },
//     {
//       path: '/service/completeOrder',
//       name: 'completeOrder',
//       meta: {
//         title: '服务完成',
//         icon: 'iconfont icon-tongguo'
//       },
//       component: () =>
//         import('@/views/service/completeOrder')
//     }, {
//       path: '/service/unusual',
//       name: 'unusual',
//       meta: {
//         title: '服务异常',
//         icon: 'iconfont icon-jinggao'
//       },
//       component: () =>
//         import('@/views/service/unusual')
//     }
//   ]
// },
// 退款管理
// {
//   path: '/refund',
//   component: Layout,
//   meta: {
//     title: '退款管理',
//     icon: 'iconfont icon-tuikuan'
//   },
//   children: [{
//     path: '/checkPending',
//     name: 'checkPending',
//     meta: {
//       title: '待审核',
//       icon: 'iconfont icon-shijian'
//     },
//     component: () =>
//       import('@/views/refund/checkPending')
//   }, {
//     path: '/refund/inReview',
//     name: 'inReview',
//     meta: {
//       title: '已通过',
//       icon: 'iconfont icon-tongguo'
//     },
//     component: () =>
//       import('@/views/refund/inReview')
//   }, {
//     path: '/refund/failed',
//     name: 'failed',
//     meta: {
//       title: '未通过',
//       icon: 'iconfont icon-guanbi'
//     },
//     component: () =>
//       import('@/views/refund/failed')
//   }]
// },
{
  path: '/consult',
  component: Layout,
  meta: {
    title: '咨询师管理',
    icon: 'iconfont icon-zixunshi'
  },
  children: [{
    path: '/consult',
    name: 'consult',
    meta: {
      title: '咨询师列表',
      icon: 'iconfont icon-zixunshi'
    },
    component: () =>
      import('@/views/consult/consultList')
  },
  {
    path: '/consultDetail',
    name: 'consultDetail',
    isHide: true,
    meta: {
      title: '咨询师详情',
    },
    component: consultDetail
  },
  {
    path: '/platformConsult',
    name: 'platformConsult',
    meta: {
      title: '平台咨询师管理',
      icon: 'iconfont icon-zixunshi'
    },
    component: () =>
      import('@/views/consult/platformConsult')
  },
  {
    path: '/schoolConsult',
    name: 'schoolConsult',
    meta: {
      title: '学校咨询师管理',
      icon: 'iconfont icon-zixunshi'
    },
    component: () =>
      import('@/views/consult/schoolConsult')
  },
  ]
},



{
  path: '/articlesMgr',
  component: Layout,
  meta: {
    title: '阳光心语',
    icon: 'el-icon-umbrella',
  },
  children: [{
    path: '/wechatarticles',
    name: 'wechatarticles',
    meta: {
      title: '文章管理',
      icon: 'el-icon-reading'
    },
    component: () =>
      import('@/views/wechatarticles/index')
  },


  ]
},
{
  path: '/courseMgr',
  component: Layout,
  meta: {
    title: '课程管理',
    icon: 'el-icon-collection',
  },
  children: [{
    path: '/subject',
    name: 'subject',
    meta: {
      title: '科目列表',
      icon: 'el-icon-reading'
    },
    component: () =>
      import('@/views/course/subject')
  },
  {
    path: '/playRecord',
    name: 'playRecord',
    meta: {
      title: '课程播放记录',
      icon: 'el-icon-reading'
    },
    component: () =>
      import('@/views/course/playRecord')
  },
  {
    path: '/questions',
    name: 'questions',
    meta: {
      title: '试题管理',
      icon: 'el-icon-reading'
    },
    component: () =>
      import('@/views/course/questions')
  }, {
    path: '/questionRecords',
    name: 'questionRecords',
    meta: {
      title: '试题测试记录',
      icon: 'el-icon-reading'
    },
    component: () =>
      import('@/views/course/questionRecords')
  },

  ]
},
{
  path: '/evaluationMgr',
  component: Layout,
  meta: {
    title: '测评管理',
    icon: 'el-icon-s-order',
  },
  children: [{
    path: '/records',
    name: 'records',
    meta: {
      title: '测评记录',
      icon: 'el-icon-tickets'
    },
    component: () =>
      import('@/views/evaluation/records')
  },


  ]
},
{
  path: '/shortVideoMgr',
  component: Layout,
  meta: {
    title: '短视频管理',
    icon: 'el-icon-video-play      ',
  },
  children: [{
    path: '/shortVideoList',
    name: 'shortVideoList',
    meta: {
      title: '视频列表',
      icon: 'el-icon-video-play          '
    },
    component: () =>
      import('@/views/shortVideo/shortVideoList')
  },
  {
    path: '/liveRoomList',
    name: 'liveRoomList',
    meta: {
      title: '直播房间管理',
      icon: 'el-icon-video-play          '
    },
    component: () =>
      import('@/views/live/liveRoomList')
  },

  ]
},
// 日志管理
{
  path: '/log',
  component: Layout,
  meta: {
    title: '日志管理',
    icon: 'el-icon-s-order',
  },
  children: [{
    path: '/registerLog',
    name: 'registerLog',
    meta: {
      title: '注册日志',
      icon: 'el-icon-reading'
    },
    component: () =>
      import('@/views/log/registerLog')
  },
  {
    path: '/operationLog',
    name: 'operationLog',
    meta: {
      title: '用户操作日志',
      icon: 'el-icon-mouse',
    },
    component: () =>
      import('@/views/log/operationLog')
  },

  ]
},


]

const router = new Router({
  routes,
  mode: 'history'
})

export default router

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


router.beforeEach((to, from, next) => {
  let token = window.sessionStorage.getItem("token");
  let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo")); //用户信息
  if (token) {
    // ROLE_ID: 1/管理员 2.高级用户 3.心理老师 4.普通用户 5.普通会员6. 超级会员 7.线上咨询师（平台咨询师） 8.学校心理老师
    if (to.path == '/home') {
      if (userInfo && userInfo.ROLE_ID == 7) {
        next({
          path: '/chat'
        })
      } else if (userInfo && userInfo.ROLE_ID == 8) {
        next({
          path: '/teacherChat'
        })
      } else {
        next()
      }
    } else {
      next()
    }

  } else {
    if (to.path === '/login' || to.path === '/liveList' || to.path === '/live') {
      next()
    } else {
      next('/login')
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js